import ProductExtendedInfo from './ProductExtendedInfo'

export default ProductExtendedInfo
